import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank');
    } else {
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        pricingSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (onClick) onClick();
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={handleClick} className={`bg-orange hover:bg-orange-soft text-white font-heading font-bold py-4 px-8 rounded-full shadow-lg transition-colors duration-300 flex items-center justify-center text-lg md:text-xl w-full md:w-auto mx-auto ${className}`} {...props} data-id="element-164">
      {children}
    </motion.button>;
}